module.exports = __webpack_public_path__ + "static/5-8458c47d2c2c4975032e37b48d5c3a88.jpg";